import LinksList from "./links-list/links-list"

const FerramentasDeModelagem = (props: any) => {
    return (<>
        <LinksList/>
    </>);
}

export default FerramentasDeModelagem;